// extracted by mini-css-extract-plugin
export default {"userImage":"UserDetails_userImage__8xLNN","userName":"UserDetails_userName__mpA2Z","userRole":"UserDetails_userRole__MrFGH"};